import {
  FilterType,
  buildMandatoryProcessTasksFilter,
  useMandatoryProcessTasks,
} from 'generated/resources/datatable.graphql'
import { SelectorAccessFragment } from 'generated/resources/graphql'

import i18n from 'modules/core/lib/i18n'

import { makeAccessOptions } from './makeAccessOptions'

export const assigneeFilter = (
  source: ReturnType<typeof useMandatoryProcessTasks>,
  accesses: SelectorAccessFragment[]
) =>
  buildMandatoryProcessTasksFilter(source, {
    type: FilterType.Id,
    categories: [
      {
        kind: 'MultipleChoice',
        operation: 'in',
        options: makeAccessOptions(accesses),
      },
    ],
    identifier: 'processesTaskList.assigneeFilter',
    path: 'assignee',
    title: i18n.t('processes.process.overview.tasks_table.assignees'),
  })
